// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const button = "HouseEditForm__button__ierCW";
export const buttonRowWrapper = "HouseEditForm__buttonRowWrapper__T6VG0";
export const buttonsRow = "HouseEditForm__buttonsRow__EXwBB";
export const form = "HouseEditForm__form__20znT";
export const formHeight = "HouseEditForm__formHeight__Fnl-h";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const item = "HouseEditForm__item__5wppa HouseEditForm__line__vW-Gg";
export const line = "HouseEditForm__line__vW-Gg";
export const medium = "500";
export const mobileTitle = "HouseEditForm__mobileTitle__ChJxW TransactionEditForm__title__4dnvO font-faces__atlasGroteskMedium__1ilbx font-faces__atlasGrotesk__rYPJr";
export const onSettingsPage = "HouseEditForm__onSettingsPage__cjGxK";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const submitItem = "HouseEditForm__submitItem__ewAzO";
export const textCenter = "HouseEditForm__textCenter__m7ET4";